import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private-routes/redirect/analytics-connect/$provider')({});
